<template>
    <!-- 列表弹窗 -->
    <el-dialog
    v-model="props.islistshow"
    @opened="handleOpen"
    :before-close="handleClose"
    title="选择验证语"
    width="800px">
        <div class="t_search_box">
            <div class="t_search_select" style="margin-top: 0;margin-bottom: 10px;" >
                <img src="../../assets/img/searchgray.png" style="width:14px" alt="">
                <el-input class="t_input_bg" @input="searchinput" size="small" v-model="searchdata.title" placeholder="请输入任务名称"  clearable />
            </div> 
        </div>
        <el-table 
        row-key="id" 
        ref="multipleTableRef" :header-cell-style="{ background: '#F1F3F9' }" :data="tableData.data" style="width: 100%" 
        @selection-change="handleSelectionChange">
            <el-table-column  type="selection" :reserve-selection="true" width="55" />
            <el-table-column prop="title" label="任务名称"  />
            <el-table-column prop="content" label="内容"  >
                <template #default="scope">
                    {{ scope.row.content }}
                </template>
            </el-table-column>
        </el-table>
        <!-- 分页 -->
        <pagechange :total="total" :nowpage="searchdata.page" @page_change="page_change" />
        <div class="t_cz_box" style="margin-top: 20px;">
            <el-button @click="restchoose"  >取消</el-button>
            <el-button  color="#4F46E5"  @click="surechoose" type="primary">确定</el-button>
        </div>
    </el-dialog>
</template>
<script setup>
import { ref, reactive, provide, onBeforeMount, onMounted, watch ,inject} from 'vue'
import { useRoute, useRouter } from 'vue-router'
import { Download,Upload } from '@element-plus/icons-vue'
//导入子组件
import pagechange from '../pagechange.vue'
import { bqlist ,Testlist,newfriendtestlist} from '@/assets/js/common.js'
// 接受父级数据，注册事件
const props = defineProps(['islistshow'])
const emits = defineEmits(['chooselist'])

//路由跳转
const router = useRouter()
//获取数据
const route = useRoute()
//动态获取接口地址
const _url2 = inject('_url2')

onMounted(() => {
    console.log('onMounted')
    getlist()
   
})

//搜索内容
const searchdata  = reactive({
    title:'',
    page:1,
    page_size:20,
})
//监听搜索文本框内容变化
const searchinput = (e)=>{
    console.log(e)
    searchdata.title = e
    searchdata.page=1
    getlist()
}
//列表内容
const tableData = reactive({
    data:[]
})

//总数
const total = ref(0)
//监听分页
const page_change = (val)=>{
    searchdata.page = val
    //人员列表
    getlist()
}
//获取列表
const getlist = ()=>{
    console.log('获取列表')
    newfriendtestlist(searchdata).then((response)=>{
        console.log('列表')
        console.log(response)
        tableData.data = response.data.data.data
        total.value = response.data.data.total
    })
}
//实际多选
const suredata = reactive({
    data:[]
})
//当前多选
const delarr = reactive({
    data:[]
})
//选择变化
const handleSelectionChange = (val)=>{
    
    if(val.length!=0){
        for(var x = 0;x<val.length;x++){
            if(x==val.length-1){
                multipleTableRef.value.toggleRowSelection(val[x],true);
                delarr.data = []
                delarr.data.push(val[x])
            }else{
                multipleTableRef.value.toggleRowSelection(val[x],false);
            }
        }
    }else{
        delarr.data = []
    }
    
    
    
   
}
//监听弹窗关闭
const handleClose = ()=>{
    emits('chooselist',suredata.data)
}
const multipleTableRef = ref(null)
//监听打开弹窗
const handleOpen = ()=>{
    multipleTableRef.value.clearSelection()
    tableData.data.forEach(key => {
        suredata.data.forEach(row => {
              if (row.id== key.id) {
                multipleTableRef.value.toggleRowSelection(key,true);
               }
        })
    })
}

//确认选择
const surechoose = ()=>{
    suredata.data = JSON.parse(JSON.stringify(delarr.data))
    emits('chooselist',suredata.data)
}
//取消选择
const restchoose = ()=>{
    emits('chooselist',suredata.data)
}

</script>
<style scoped>
:deep(.t_input_bg .el-input__wrapper)  {
    background-color: #F1F3F9;
    box-shadow: 0 0 0 0 black;
}
:deep(.el-table__header-wrapper .el-checkbox__inner){
    display: none;
}

</style>

